import _ from 'lodash'
import styled from 'styled-components'
import { memo, useCallback } from 'react'
import { Label } from '../../text/Text'
import { Checkbox } from '@fluentui/react/lib/Checkbox'
import { TooltipHost } from '@/components/tooltip/TooltipHost'
import { DirectionalHint } from '@fluentui/react/lib/Callout'
import { FrequencyDropdown } from '../../dropdown/FrequencyDropdown'
import { itemHelper } from '../../../common/src/helpers'
import { LocalizedDatePicker } from '../../pickers/LocalizedDatePicker'
import { useTranslation } from 'react-i18next'
import { Icon } from '@fluentui/react/lib/Icon'
import { FlexRow } from '../../layout/FlexContainer'
import { endOfDay } from 'date-fns'

const buttonTooltipStyles = props => ({
  root: {
    color: props.theme.palette.black,
    marginTop: '-53px',
    zIndex: '2',
    marginLeft: '85px',
  },
})

const StyledDiv = styled(FlexRow)`
  flex-wrap: wrap-reverse;
`

const StyledFrequencyDropdown = styled(FrequencyDropdown)`
  width: 306px;
`

const UntilDateContainer = styled(FlexRow)`
  align-items: center;
`

const UntilCheckbox = styled(Checkbox)`
  margin-right: 8px;
`

const UntilDatePicker = styled(LocalizedDatePicker)`
  flex: 1;
`

const UntilTooltip = styled(TooltipHost).attrs({
  directionalHint: DirectionalHint.leftCenter,
})``

export const ItemRecurrencePanelPart = memo(
  ({ frequency, untilDate, onChangeFrequency, onChangeUntilDate, frequencyKeys, isReminder = false }) => {
    const { t } = useTranslation()

    const onChangeCheckbox = useCallback(
      (evt, value) => {
        if (value) {
          return onChangeUntilDate(new Date())
        }
        return onChangeUntilDate()
      },
      [onChangeUntilDate]
    )

    const onChangeUntilDateEndOfDay = useCallback(
      date => {
        const adjustedDate = date && endOfDay(date)
        onChangeUntilDate(adjustedDate)
      },
      [onChangeUntilDate]
    )

    const isRecurring = frequency && frequency !== itemHelper.FREQUENCY_TYPE.NEVER
    const hasUntil = !!untilDate
    const hasChangeUntil = _.isFunction(onChangeUntilDate)
    return (
      <>
        <StyledDiv>
          {isReminder && (
            <TooltipHost content={t('item.reminder.recurrence_tooltip')} styles={buttonTooltipStyles} id={'tooltipID'}>
              <Icon iconName={'Info'} />
            </TooltipHost>
          )}
          <StyledFrequencyDropdown
            label={t('date.recurrence')}
            selectedKey={frequency}
            onChange={onChangeFrequency}
            frequencyKeys={frequencyKeys}
          />
        </StyledDiv>
        {isRecurring && hasChangeUntil && (
          <>
            <Label>{t('date.until_date')}</Label>
            <UntilDateContainer>
              <UntilTooltip content={t('date.frequency.tooltip')}>
                <UntilCheckbox checked={hasUntil} onChange={onChangeCheckbox} />
              </UntilTooltip>
              {hasUntil && <UntilDatePicker value={untilDate} onSelectDate={onChangeUntilDateEndOfDay} />}
            </UntilDateContainer>
          </>
        )}
      </>
    )
  }
)
